/**
 * @generated SignedSource<<534209e5dc05a317f1e79aa6aa41c57a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DownloadButton_node$data = {
  readonly __typename: string;
  readonly content?: {
    readonly id?: string;
    readonly url?: URIString;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useItemHandleFragment" | "useNodeSecurity_node">;
  readonly " $fragmentType": "DownloadButton_node";
};
export type DownloadButton_node$key = {
  readonly " $data"?: DownloadButton_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"DownloadButton_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DownloadButton_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemHandleFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useNodeSecurity_node"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "type": "File",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/)
              ],
              "type": "File",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "VaultItem",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "1cfa00c0b3ebbd64b08af3cbd78784d1";

export default node;
